var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "ibox-content" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Nombre")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.nombre,
                      expression: "servicio_json.nombre",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre", readonly: "", type: "text" },
                  domProps: { value: _vm.servicio_json.nombre },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.servicio_json, "nombre", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Código de integración")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.UUID,
                      expression: "servicio_json.UUID",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Código de integración", readonly: "" },
                  domProps: { value: _vm.servicio_json.UUID },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.servicio_json, "UUID", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.confirmable,
                      expression: "servicio_json.confirmable",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: { type: "checkbox", "data-switchery": "true" },
                  domProps: {
                    checked: Array.isArray(_vm.servicio_json.confirmable)
                      ? _vm._i(_vm.servicio_json.confirmable, null) > -1
                      : _vm.servicio_json.confirmable,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.servicio_json.confirmable,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.servicio_json,
                              "confirmable",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.servicio_json,
                              "confirmable",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.servicio_json, "confirmable", $$c)
                      }
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Duracion")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.duracion,
                      expression: "servicio_json.duracion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre", readonly: "", type: "text" },
                  domProps: { value: _vm.servicio_json.duracion },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.servicio_json,
                        "duracion",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.servicio_json.area
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Area")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.servicio_json.area.nombre,
                          expression: "servicio_json.area.nombre",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        placeholder: "Nombre",
                        readonly: "",
                        type: "text",
                      },
                      domProps: { value: _vm.servicio_json.area.nombre },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.servicio_json.area,
                            "nombre",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Especialidad")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.especialidad.nombre,
                      expression: "servicio_json.especialidad.nombre",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Nombre", readonly: "", type: "text" },
                  domProps: { value: _vm.servicio_json.especialidad.nombre },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.servicio_json.especialidad,
                        "nombre",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.dias_preparacion,
                      expression: "servicio_json.dias_preparacion",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Dias de preparacion", type: "number" },
                  domProps: { value: _vm.servicio_json.dias_preparacion },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.servicio_json,
                        "dias_preparacion",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Flujo")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.servicio_json.id_flujo,
                        expression: "servicio_json.id_flujo",
                      },
                    ],
                    staticClass: "custom-select",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.servicio_json,
                          "id_flujo",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v("Seleccione un elemento"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.flujos_list, function (flujo, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: flujo.id } },
                        [
                          _vm._v(
                            "\r\n                                " +
                              _vm._s(flujo.nombre) +
                              "\r\n                            "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Indicaciones")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.indicaciones,
                      expression: "servicio_json.indicaciones",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { rows: "4" },
                  domProps: { value: _vm.servicio_json.indicaciones },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.servicio_json,
                        "indicaciones",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Texto Personalizado Voucher Agendamiento")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.texto_personalizado_agendamiento,
                      expression:
                        "servicio_json.texto_personalizado_agendamiento",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { rows: "2" },
                  domProps: {
                    value: _vm.servicio_json.texto_personalizado_agendamiento,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.servicio_json,
                        "texto_personalizado_agendamiento",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(8),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.agendable,
                      expression: "servicio_json.agendable",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "cb-agendable",
                    type: "checkbox",
                    "data-switchery": "true",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.servicio_json.agendable)
                      ? _vm._i(_vm.servicio_json.agendable, null) > -1
                      : _vm.servicio_json.agendable,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.servicio_json.agendable,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.servicio_json, "agendable", $$c)
                        }
                      },
                      function ($event) {
                        return _vm.handleAgendableChange()
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(9),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.agendable_web,
                      expression: "servicio_json.agendable_web",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "cb-agendable-web",
                    type: "checkbox",
                    "data-switchery": "true",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.servicio_json.agendable_web)
                      ? _vm._i(_vm.servicio_json.agendable_web, null) > -1
                      : _vm.servicio_json.agendable_web,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.servicio_json.agendable_web,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_web",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_web",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.servicio_json, "agendable_web", $$c)
                        }
                      },
                      function ($event) {
                        return _vm.changeAgendable("web")
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(10),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.agendable_ejecutivo,
                      expression: "servicio_json.agendable_ejecutivo",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "cb-agendable-ejecutivo",
                    type: "checkbox",
                    "data-switchery": "true",
                  },
                  domProps: {
                    checked: Array.isArray(
                      _vm.servicio_json.agendable_ejecutivo
                    )
                      ? _vm._i(_vm.servicio_json.agendable_ejecutivo, null) > -1
                      : _vm.servicio_json.agendable_ejecutivo,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.servicio_json.agendable_ejecutivo,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_ejecutivo",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_ejecutivo",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.servicio_json,
                            "agendable_ejecutivo",
                            $$c
                          )
                        }
                      },
                      function ($event) {
                        return _vm.changeAgendable("ejecutivo")
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(11),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.agendable_whatsapp,
                      expression: "servicio_json.agendable_whatsapp",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "cb-agendable-whatsapp",
                    type: "checkbox",
                    "data-switchery": "true",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.servicio_json.agendable_whatsapp)
                      ? _vm._i(_vm.servicio_json.agendable_whatsapp, null) > -1
                      : _vm.servicio_json.agendable_whatsapp,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.servicio_json.agendable_whatsapp,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_whatsapp",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_whatsapp",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.servicio_json, "agendable_whatsapp", $$c)
                        }
                      },
                      function ($event) {
                        return _vm.changeAgendable("whatsapp")
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group" }, [
              _vm._m(12),
              _vm._v(" "),
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servicio_json.agendable_telefono,
                      expression: "servicio_json.agendable_telefono",
                    },
                  ],
                  staticClass: "js-switch",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: "cb-agendable-telefono",
                    type: "checkbox",
                    "data-switchery": "true",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.servicio_json.agendable_telefono)
                      ? _vm._i(_vm.servicio_json.agendable_telefono, null) > -1
                      : _vm.servicio_json.agendable_telefono,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.servicio_json.agendable_telefono,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_telefono",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.servicio_json,
                                "agendable_telefono",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.servicio_json, "agendable_telefono", $$c)
                        }
                      },
                      function ($event) {
                        return _vm.changeAgendable("telefono")
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.list.length > 0 ? _c("hr") : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "row",
              staticStyle: {
                "border-bottom": "1px solid #bfbfbfee",
                "margin-bottom": "16px",
              },
            },
            [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Establecimiento " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("multiselect", {
                        attrs: {
                          label: "nombre",
                          multiple: true,
                          taggable: true,
                          "track-by": "id",
                          options: _vm.establecimientos_list,
                        },
                        model: {
                          value: item.establecimientos,
                          callback: function ($$v) {
                            _vm.$set(item, "establecimientos", $$v)
                          },
                          expression: "item.establecimientos",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Estrategia " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.estrategia,
                            expression: "item.estrategia",
                          },
                        ],
                        staticClass: "custom-select",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              item,
                              "estrategia",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { disabled: "", value: "" } }, [
                          _vm._v("Seleccione un elemento"),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          _vm.estrategias_list,
                          function (estrategia, index3) {
                            return _c(
                              "option",
                              {
                                key: index3,
                                domProps: { value: estrategia.id },
                              },
                              [
                                _vm._v(
                                  "\r\n                                " +
                                    _vm._s(estrategia.nombre) +
                                    "\r\n                            "
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Tipo Cita " + _vm._s(index + 1))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("multiselect", {
                        attrs: {
                          label: "abrev",
                          multiple: true,
                          taggable: true,
                          "track-by": "id",
                          options: _vm.tipo_cita_list,
                        },
                        model: {
                          value: item.tipo_citas,
                          callback: function ($$v) {
                            _vm.$set(item, "tipo_citas", $$v)
                          },
                          expression: "item.tipo_citas",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Eliminar")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        on: {
                          click: function ($event) {
                            return _vm.eliminar(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fal fa-times" })]
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-4" }, [
            _c(
              "a",
              { attrs: { href: "javascript:void(0)" }, on: { click: _vm.add } },
              [_vm._v("Añadir Estrategia")]
            ),
          ]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-footer" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4 offset-md-8" }, [
          _c("div", { staticClass: "btn-group float-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "submit" },
                on: { click: _vm.save },
              },
              [
                _c("i", { staticClass: "fal fa-save" }),
                _vm._v(" Guardar\r\n                    "),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-barcode" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Confirmable ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content":
              "Permitir realizar la confirmación de las horas de este servicio.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-tag" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Preparación("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content":
              "Dias que se deben tener de preparacion para el usuario.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-addon" }, [
        _c("i", { staticClass: "fal fa-clock" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Agendable ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content": "Permitir agendar.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Agendable Web ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content": "Permitir agendar via web.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Agendable Ejecutivo ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content": "Permitir agendar via web a ejecutivos.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Agendable Whatsapp ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content": "Permitir agendar via canal whatsapp.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _vm._v("Agendable Teléfono ("),
      _c(
        "a",
        {
          staticClass: "text-navy",
          attrs: {
            "data-toggle": "popover",
            "data-placement": "auto",
            "data-content": "Permitir agendar via canal teléfono.",
          },
        },
        [_c("i", { staticClass: "fa fa-question-circle" })]
      ),
      _vm._v(")"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }